import React from "react";
import { Button, Container, Text, Title } from "@mantine/core";

const ErrorFallback: React.FC = () => {
  return (
    <Container size="sm" py="xl">
      <Title order={2}>Something went wrong</Title>
      <Text mt="sm" c="dimmed">
        We hit an unexpected error. Try reloading the page.
      </Text>
      <Button mt="md" onClick={() => window.location.reload()}>
        Reload
      </Button>
    </Container>
  );
};

export default ErrorFallback;
